import React, { useState } from 'react';
import { Add, Edit } from '@mui/icons-material';

import Dialog from '@/components/dataDisplay/Dialog';
import Button from '@/components/input/Button';
import theme from '@/constants/theme';

import CreateEditStageForm from '../CreateEditStageForm';

interface Props {
  routeId: string;
  stageId?: string;
}

const CreateEditStageButton: React.FC<Props> = ({ routeId, stageId }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const buttonName = stageId ? 'Editar Etapa' : 'Añadir Etapa';

  return (
    <>
      <Button variant={stageId ? 'outline' : 'primary'} Icon={stageId ? Edit : Add} onClick={handleOpen}>
        {buttonName}
      </Button>
      <Dialog open={open} setOpen={setOpen} disabledBackdropClick>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            width: '640px',
            maxWidth: '100%',
            maxHeight: '100%',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <h2>{buttonName}</h2>
            { !stageId && <p style={{ color: theme.colors.text.caption }}>
              Las etapas añadidas se ligaran directamente a esta ruta.
            </p>}
          </div>
          <CreateEditStageForm
            routeId={routeId}
            stageId={stageId}
            onSubmit={handleCancel}
            onCancel={handleCancel}
          />
        </div>
      </Dialog>
    </>
  );
};

export default CreateEditStageButton;
